module.exports = __webpack_public_path__ + "static/media/charity.68c7c8a3.png";